import * as login from "./components/login/index";

let inst = login.bind();
let TokenExpires = localStorage.getItem("TokenExpires");
let epochNowSeconds = new Date().getTime() / 1000;

inst.toggleAnimation(!(epochNowSeconds > TokenExpires));

window.login = inst;


// WEBPACK FOOTER //
// ./project/client/src/core/login.js